module.exports = __webpack_public_path__ + "img/contrasena.81606ee7.svg";